import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "design-system/molecules/Select"
import { Images, Shuffle } from "lucide-react"
import { useTranslation } from "react-i18next"
import { GoalMediaStrategy, GoalMediaStrategyEnum } from "schema"

type GoalMediaStrategySelectProps = {
  value?: GoalMediaStrategy
  onValueChange: (value: GoalMediaStrategy) => void
  disabled?: boolean
  className?: string
}

export const GoalMediaStrategySelect = ({
  value,
  onValueChange,
  disabled,
  className,
}: GoalMediaStrategySelectProps) => {
  const { t } = useTranslation()

  return (
    <Select
      value={value}
      onValueChange={(value) => onValueChange(value as GoalMediaStrategy)}
      disabled={disabled}
    >
      <SelectTrigger className={className}>
        <SelectValue placeholder={t("campaigns.goals.mediaStrategy.placeholder")} />
      </SelectTrigger>
      <SelectContent>
        <SelectItem
          value={GoalMediaStrategyEnum.ShareAll}
          textValue={t("campaigns.goals.mediaStrategy.shareAll")}
          description={t("campaigns.goals.mediaStrategy.shareAllDescription")}
        >
          <div className="flex items-center gap-2">
            <Images className="size-4" />
            <span>{t("campaigns.goals.mediaStrategy.shareAll")}</span>
          </div>
        </SelectItem>
        <SelectItem
          value={GoalMediaStrategyEnum.RandomPick}
          textValue={t("campaigns.goals.mediaStrategy.randomPick")}
          description={t("campaigns.goals.mediaStrategy.randomPickDescription")}
        >
          <div className="flex items-center gap-2">
            <Shuffle className="size-4" />
            <span>{t("campaigns.goals.mediaStrategy.randomPick")}</span>
          </div>
        </SelectItem>
      </SelectContent>
    </Select>
  )
}
